import { SubscribeType } from "amazon-ivs-web-broadcast";

export class BroadcastStrategy {
  constructor() {
    this.shouldPublishParticipant = this.shouldPublishParticipant.bind(this);
    this.shouldSubscribeToParticipant =
      this.shouldSubscribeToParticipant.bind(this);
    this.subscribeConfiguration = this.subscribeConfiguration.bind(this);
  }

  // Determine if the local participant should publish to the stage
  shouldPublishParticipant() {
    return false; // We're only viewing, not publishing
  }

  // Determine if we should subscribe to a remote participant
  shouldSubscribeToParticipant(participant) {
    return true; // Subscribe to all participants
  }

  // Configure how we subscribe to participants
  subscribeConfiguration(participant) {
    return {
      video: SubscribeType.WATCH, // Subscribe to video
      audio: SubscribeType.WATCH, // Subscribe to audio
    };
  }
}
